import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Input, InputGroupText, Tooltip } from "reactstrap";
import { MdOutlineEmail } from 'react-icons/md';
import { BsLink45Deg, BsWhatsapp } from 'react-icons/bs';
import { FaRegCopy } from 'react-icons/fa';
import copy from "copy-to-clipboard";
import ShareModalIcon from "../../assets/share_modal_icon.png";

function ShareModal({ showShareModal, setShowShareModal, link, setLink }) {
    const [copied, setCopied] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    const copyLink = () => {
        setTooltipOpen(true);
        setCopied(true);
        copy(link);
    }

    const toggleShare = () => {
        setShowShareModal(!showShareModal);
        setCopied(false)
        setLink('');
    };

    const handleMail = () => {
        try {
            window.location.href = (`mailto:nesiyatova@gmail.com?body=Link: ${link}`);
        } catch (err) {
            console.log(err)
        }
    }

    const handleWhatsApp = () => {
        try {
            if (window?.screen?.width >= 1024) {
                window.open(
                    `https://web.whatsapp.com/send?&text=${link}`,
                    "_blank"
                )
            }
            else {
                window.location.href = (`whatsapp://send?text=${link}`);
            }
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <Modal className='share modal-dialog-centered' isOpen={showShareModal} toggle={toggleShare}>
            <ModalHeader>
                <div className='select_route_header_section'>
                    <img src={ShareModalIcon} alt='' />
                    <p className='select_route_heading'>Share</p>
                </div>
                <p className='select_route_desc'>You can copy this link</p>
            </ModalHeader>
            <ModalBody>
                <Form className='share_form'>
                    <FormGroup className='form_group'>
                        <InputGroupText>
                            <BsLink45Deg size={30} color='#FF8028' />
                        </InputGroupText>
                        <Input type="text"
                            defaultValue={link}
                            disabled
                            autoComplete="off" />
                        <InputGroupText>
                            <Button type='button' onClick={() => copyLink()} id='DisabledAutoHideExample'><FaRegCopy size={20} /></Button>
                            {copied && <Tooltip
                                placement="top"
                                isOpen={tooltipOpen}
                                // autohide={false}
                                target="DisabledAutoHideExample"
                                toggle={toggle}
                            >Link Copied!</Tooltip>}
                        </InputGroupText>
                    </FormGroup>
                    <p>Or share via</p>
                    <div className='buttons'>
                        <Button type='button' className='whatsapp' onClick={handleWhatsApp}><BsWhatsapp className='whatsapp_icon' size={18} />Whatsapp</Button>
                        <Button type='button' className='email' onClick={handleMail}><MdOutlineEmail className='email_icon' size={22} />Email</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default ShareModal